import React, { useEffect } from 'react';
import { TitleContentLayout } from '@zen/common-app-parts';
import { DexOperationsStore } from '@zen-dex/utils';
import { TxCountChangedStore } from '../../stores/ChangeNotificationsStore';
import OperationsTable from './components/OperationsTable';

export default function MyOrdersScreen() {
  const operationsStore = DexOperationsStore.useStore();
  const {
    state: { changed },
    actions: { clear: clearTxCountChanged },
  } = TxCountChangedStore.useStore();

  // clear on mount
  useEffect(() => {
    clearTxCountChanged();
  }, [clearTxCountChanged, changed]);

  useOperationsPolling(operationsStore);

  return (
    <TitleContentLayout dark noPadding title="Operations">
      <OperationsTable
        filter={operationsStore.state.filter}
        setFilter={operationsStore.actions.setFilter}
        items={operationsStore.state.items}
        loading={operationsStore.state.loading.items}
      />
    </TitleContentLayout>
  );
}

/**
 * Starts and stops the polling
 */
function useOperationsPolling(operationsStore) {
  useEffect(() => {
    operationsStore.actions.poll.start();

    return () => {
      operationsStore.actions.poll.stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
